import { useAssessorResetPassword } from "@/api/console/assessor/useAssessorResetPassword";
import InputGroup from "@/components/InputGroup";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import toast from "@/lib/toast";
import {
  AssessorResetPassword,
  assessorResetPasswordSchema,
} from "@/schema/console/assessors/AssessorResetPassword";
import useAssessorDialog from "@/src/console/(auth)/assessors/_hooks/useAssessorDialog";
import { SpinnerIosRegular } from "@fluentui/react-icons";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

function ResetPasswordDialog() {
  const { t } = useTranslation();
  const { type, assessor, resetDialog } = useAssessorDialog();

  const assessorId = assessor?.id ?? -1;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<AssessorResetPassword>({
    resolver: zodResolver(assessorResetPasswordSchema),
    defaultValues: {
      password: "",
    },
  });
  const { trigger, isMutating } = useAssessorResetPassword(assessorId, {
    onSuccess: (data) => {
      toast.success(data.message);
      resetDialog();
    },
  });

  return (
    <div>
      <Dialog
        open={type === "change-password"}
        onOpenChange={(open) => !open && resetDialog()}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{t("change-password")}</DialogTitle>
          </DialogHeader>
          <form
            onSubmit={(event) => {
              event.preventDefault();
              handleSubmit((data) => {
                trigger(data);
              })();
            }}
          >
            <div className="flex flex-col gap-6 px-6 pb-5 pt-4">
              <InputGroup
                required
                label={t("password")}
                name="password"
                type="password"
                error={errors.password?.message}
                register={register("password", {
                  required: t("password-required"),
                  validate: (value) => {
                    if (!value) return t("password-required");
                    if (value.length < 8) {
                      return t("Password-digit-message");
                    }
                  },
                })}
              />
              <Button
                isLoading={isMutating}
                LoadingComponent={
                  <SpinnerIosRegular className="animate-spin" />
                }
                type="submit"
              >
                {t("change-password")}
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default ResetPasswordDialog;
